export const SET_DARK_MODE = 'SET_DARK_MODE';
export const SET_VIEWPORT_MOBILE = 'SET_VIEWPORT_MOBILE';
export const SET_ACCOUNT = 'SET_ACCOUNT';

export const SET_ACCOUNTS = 'SET_ACCOUNTS';
export const SET_JOBS = 'SET_JOBS';
export const SET_CUSTOMERS = 'SET_CUSTOMERS';
export const SET_MOMENTS = 'SET_MOMENTS';
export const SET_JOB_CONFIGS = 'SET_JOB_CONFIGS';
export const SET_JOB_CONFIG_TEMPLATES = 'SET_JOB_CONFIG_TEMPLATES';
export const SET_MEMBERS = 'SET_MEMBERS';
export const SET_KIOSKS = 'SET_KIOSKS';
export const SET_KIOSKS_V2 = 'SET_KIOSKS_V2';
export const SET_CONTENT_PROVIDERS = 'SET_CONTENT_PROVIDERS';
export const SET_MARKETING = 'SET_MARKETING';
export const SET_PURCHASES = 'SET_PURCHASES';
export const SET_UPLOADS = 'SET_UPLOADS';
export const SET_MOMENT_UPLOADS = 'SET_MOMENT_UPLOADS';
export const SET_BILLINGS = 'SET_BILLINGS';
export const SET_ACCOUNT_BILLINGS = 'SET_ACCOUNT_BILLINGS';
export const SET_ACCOUNT_PRICINGS = 'SET_ACCOUNT_PRICINGS';
export const SET_BILLING_EXPORT_SCHEDULES = 'SET_BILLING_EXPORT_SCHEDULES';
export const SET_GUESTS = 'SET_GUESTS';
export const SET_ACCESS_CODE_PAGES = 'SET_ACCESS_CODE_PAGES';

export const SET_SALES_REPORT = 'SET_SALES_REPORT';
export const SET_PHOTOG_HOURLY_REPORT = 'SET_PHOTOG_HOURLY_REPORT';
export const SET_ANALYTICS_REPORT = 'SET_ANALYTICS_REPORT';

export const GET_KIOSK_PRINT_SIZES = 'GET_KIOSK_PRINT_SIZES';
export const POPULATE_PRINT_SIZES = 'POPULATE_PRINT_SIZES'
export const GET_KIOSK_PRICINGS = 'GET_KIOSK_PRICINGS';
export const CREATE_KIOSK_PRICING = 'CREATE_KIOSK_PRICING';
export const UPDATE_KIOSK_PRICING = 'UPDATE_KIOSK_PRICING';

export const GET_PRODUCT_BACKGROUNDS = 'GET_PRODUCT_BACKGROUNDS';
export const GET_PRODUCT_OVERLAYS = 'GET_PRODUCT_OVERLAYS';
export const GET_PRODUCT_KNOCKOUT_PAIRS = 'GET_PRODUCT_KNOCKOUT_PAIRS';

export const SET_GRID_STATE = 'SET_GRID_STATE';
export const RESET_GRID_STATE = 'RESET_GRID_STATE';

export const ADD_FILTER = 'ADD_FILTER';
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTER_OPERATOR = 'SET_FILTER_OPERATOR';
export const SET_FILTER_MODEL_OPERATOR = 'SET_FILTER_MODEL_OPERATOR';
export const UNSET_FILTER = 'UNSET_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
